import { defineMessages } from 'react-intl';

export const messages: {
	adminModalHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userModalHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	getStartedButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewGoalTypesButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userContentIntroduction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	adminModalHeader: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.admin-modal-header',
		defaultMessage: 'Build OKRs and other frameworks with custom goal types',
		description: 'Header for changeboarding modal of success measures for admins',
	},
	userModalHeader: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.user-modal-header',
		defaultMessage: 'Model OKRs and more with goal types and success measures',
		description: 'Header for changeboarding modal of success measures for users',
	},
	getStartedButton: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.get-started-button',
		defaultMessage: 'Get started',
		description: 'Text that prompts the user to get started on their experience',
	},
	dismissButton: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Text that prompts the user to dismiss the experience',
	},
	viewGoalTypesButton: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.view-goal-types-button',
		defaultMessage: 'View goal types',
		description: 'Text that prompts the user view goal types experience',
	},
	moreButton: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.more-button',
		defaultMessage: 'More on goal types',
		description:
			'Text that when clicked takes user to a link where they can learn more about goal types',
	},
	adminContent: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.admin-content',
		defaultMessage:
			'You can use multiple goal types or stick to just one—there’s enough flexibility to create the structure you need.',
		description: 'More benefits around success measures',
	},
	userContent: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.user-content',
		defaultMessage:
			'Success measures have their own updates like goals and link directly with metrics to show a goal’s progress.',
		description: 'More benefits around success measures',
	},
	userContentIntroduction: {
		id: 'success-measures-changeboarding-modal.goals-screen-space-flags.user-introduction',
		defaultMessage:
			'You can now use different types of goals and add success measures, like key results or KPIs, to track the specific outcomes you’re looking for.',
		description: 'User: introduction around goal types',
	},
});
